export default "__VITE_ASSET__CNmNDJjb__"